export default __webpack_public_path__ + "static/media/time-cat.457c434f.gif";